import React from 'react'
import AppLogo from '../assets/footer_logo.svg'
import { Link } from 'react-router-dom'
import { appRoutes } from '../utils/app_routes'

const Footer = () => {
    return (
        <footer className='w-full'>
            <div className='px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%] text-white bg-black'>
                <div className='py-10 flex items-center gap-10 flex-col'>
                    <Link to={appRoutes.home} >
                        <img src={AppLogo} alt="App Logo" />
                    </Link>
                    <div className='flex gap-[30px] xl:gap-[58px] items-center'>
                        <Link to={appRoutes.shop} className={`footer-navs hover:text-primary `}>Shop</Link>
                        <Link to={appRoutes.about} className={`footer-navs hover:text-primary `}>About</Link>
                        <Link to={appRoutes.blog} className={`footer-navs hover:text-primary `}>Blog</Link>
                        <Link to={appRoutes.contact} className={`footer-navs hover:text-primary `}>Contact</Link>
                    </div>
                </div>
                <p className='w-full bg-[#FFFFFF40] h-[1px]'></p>
                <div className='py-10 flex flex-col gap-6 items-center text-[15px] md:text-[16px] font-[400] leading-[26px] text-[#B2B2B2]'>
                    <p className='w-[80%] max-w-[966px]'>
                        Supreme Nutra Shop® may make changes to products from time to time. Please consult the label on the product that you purchased for the most accurate product information.
                    </p>
                    <p className='w-[85%] max-w-[1103px]'>
                        The information contained within this site is not intended as a substitute for professional medical advice. If you have or suspect you have any medical condition, you are urged to consult your healthcare provider.
                    </p>
                    <div className='w-[88%] py-6 md:py-[30px] border border-[#FFFFFF40] flex justify-center items-center'>
                        <p className='max-w-[1013px] text-center'>
                            *These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease.
                        </p>
                    </div>
                </div>
            </div>
            <div className='py-3 px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%] text-[14px] xl:text-[16px] font-[400] leading-[26px] text-black bg-primary flex flex-col gap-2 md:flex-row justify-between items-center '>
                <p>© 2024 Supreme Nutra Shop. All Rights Reserved</p>
                <div className='flex gap-2'>
                    <Link to={appRoutes['terms-of-service']} className='hover:text-white'>Terms of Service</Link>
                    <p> | </p>
                    <Link to={appRoutes['privacy-policy']} className='hover:text-white'>Privacy Policy</Link>
                </div>
            </div>
        </footer>
    )
}

export default Footer